import React from 'react'
import {
    Form,
  Input,
  Radio,
  Space,
  Button,Selector,TextArea,ImageUploader,DatePicker,NavBar,Image,Picker,Toast,Grid
} from 'antd-mobile-v5';
import dayjs from 'dayjs'
import { RightOutline } from 'antd-mobile-icons'

import {
    GetDataDictionarysByCode,SaveNNFile,SavePlanetInfo,GetPlanetInfo,GetSystemMemorys
  } from '../../service/service';

import BottomMenu from '../../comronent/BottomMenu/index';
import '../../assets/font/font.css'
import { environment } from '../../service/baseUrl';

import '../Planet/index.css'
import { useNavigate, useParams, useLocation } from 'react-router-dom';
// import moment from 'moment';
// moment.locale('zh-cn');

const withNavigate = (WrappedComponent) => {
    return (props) => {
        const params = useParams();
        const navigate = useNavigate();
        const location = useLocation();
        return <WrappedComponent {...props} params={params} navigate={navigate} location={location} />;
    };
};

class Index extends React.Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            fileList: [],

            visibleOne: false,
            valuePickerOne: "0",
            textPickerOne: "请选择",
            pickerOne: [
                [
                ]
            ],

            visibleTwo: false,
            valuePickerTwo: "0",
            textPickerTwo: "请选择",
            pickerTwo: [
                [
                ]
            ],

            imgName: "",
            userInfo: {},
            planetInfo: {},
            id: 0,
        };
    }

    componentDidMount() {
        var that = this;
        GetDataDictionarysByCode("NNSZGX").then(res => {
            if (res.success) {
                var arry = [];
                res.result.map(item => {
                    arry.push({ label: item.displayName, value: item.id })
                })
                that.setState({
                    pickerOne: [arry]
                })
            }
        })

        GetDataDictionarysByCode("XCX_CH").then(res => {
            if (res.success) {
                var arry = [];
                res.result.map(item => {
                    arry.push({ label: item.displayName, value: item.id })
                })
                that.setState({
                    pickerTwo: [arry]
                })
            }
        })

        
        const { location } = this.props;
        const { id } = location.state || {}; // 获取 URL 参数
        if (id) {
            GetPlanetInfo(id).then(res => {
                if (res.success) {
                    var result = res.result;

                    this.formRef.current.setFieldsValue({
                        Name: res.result.name,
                        FamilyRelationOne: res.result.familyRelationOneId,
                        // FamilyRelationTwo: res.result.familyRelationTwoId,
                        Sex: res.result.sex,
                        Birthday: new Date(res.result.birthday),
                        DeadDate: new Date(res.result.deadDate),
                    })

                    setTimeout(() => {
                        var item1 = that.state.pickerOne[0].filter(x => x.value == result.familyRelationOneId);
                        // var item2 = that.state.pickerTwo[0].filter(x => x.value == result.familyRelationTwoId);
                        that.setState({
                            valuePickerOne: item1[0] == null ? 0 : item1[0].value,
                            textPickerOne: item1[0] == null ? "请选择" : item1[0].label,
                            // valuePickerTwo: item2[0] == null ? 0 : item2[0].value,
                            // textPickerTwo: item2[0] == null ? "请选择" : item2[0].label
                        })
                    }, 1000);

                    var list = [{
                        key: 999,
                        url: environment.apiEndpoint + "/NNFiles/Img/" + result.headImg,
                        thumbnailUrl: environment.apiEndpoint + "/NNFiles/Img/" + result.headImg,
                    }]
                    that.setState({
                        id: id,
                        imgName: result.headImg,
                        planetInfo: result,
                        fileList: list,
                    })
                }
            })
        } else {
            this.formRef.current.setFieldsValue({ Sex: true, Birthday: new Date('1950-01-01') })
        }

        var user = localStorage.getItem("user");
        if (user == null || user == undefined) {
            return;
        }

        this.setState({
            userInfo: JSON.parse(user)
        })
    }

    submitForm = () => {
        var that = this;
        this.formRef.current.validateFields()
            .then(values => {
                if (values.Birthday != undefined) {
                    values.Birthday = dayjs(values.Birthday).format("YYYY-MM-DD");
                }
                if (values.DeadDate != undefined) {
                    values.DeadDate = dayjs(values.DeadDate).format("YYYY-MM-DD");
                }
                
                const submitData = {
                    ...that.state.planetInfo,
                    ...values,
                    FamilyRelationOneId: this.state.valuePickerOne,
                    // FamilyRelationTwoId: this.state.valuePickerTwo,
                    HeadImg: this.state.imgName
                };

                SavePlanetInfo(submitData).then(res => {
                    if (res.success) {
                        Toast.show({ icon: 'success', content: '提交成功！' });
                        setTimeout(() => {
                            that.props.navigate('/index', { replace: true });
                        }, 2000);
                    }

                })
            })
            .catch(error => {
                if (error.errorFields) {
                    Toast.show({ icon: 'fail', content: '请检查表单' });
                } else {
                    Toast.show({ icon: 'fail', content: error.message || '提交失败' });
                }
            });
    };
    


    render() {

        return (
            <div className="planet" style={{ backgroundColor: "rgb(227 227 227)", height: "100%" }}>
                <NavBar back='返回' onBack={() => {
                    if (this.state.id == 0) {
                        this.props.navigate('/index', { replace: true }); // 传递状态
                    } else {
                        this.props.navigate('/home?planetId=' + this.state.id, { replace: true, state: { id: this.state.id } });
                    }
                }}>
                </NavBar>

                <div style={{ fontSize: "20px", textAlign: "center", marginBottom: "15px", fontWeight: "600" }}>
                    {
                        this.state.id == 0 ? "创建星球" : "编辑星球"
                    }
                </div>

                <div style={{
                    width: "90%", marginLeft: "5%", paddingTop: "10px", backgroundColor: "#fff"
                    , borderTopLeftRadius: "10px", borderTopRightRadius: "10px", marginTop: "10px"
                }}>
                    <Form
                        name='form'
                        ref={this.formRef}
                        layout='horizontal'
                        footer={
                            <div>
                                <div style={{
                                    backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/13-09.png')"
                                    , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "38px"
                                    , marginLeft: "10%", width: "80%", textAlign: "center", fontSize: "17px", lineHeight: "38px"
                                    , fontWeight: "600", color: "#fff"
                                }} type='submit' onClick={()=>{
                                    this.submitForm();
                                }}>
                                    确 定
                                </div>
                            </div>
                        }
                    >


                        <Form.Item
                            name='Name'
                            label='逝者姓名'
                            rules={[{ required: true, message: '请输入相关内容' }]}
                        >
                            <Input onChange={console.log} placeholder='请输入相关内容' />
                        </Form.Item>

                        <Form.Item className="xinyang" name='FamilyRelationOne' label="你是Ta的">
                            <div onClick={() => {
                                this.setState({
                                    visibleOne: true
                                })
                            }} style={{
                                display: "flex",
                                alignItems: "center", // 垂直居中
                                justifyContent: "flex-end", // 内容右对齐
                            }}>
                                <span style={{ fontSize: "15px", textAlign: "right", marginRight: "10px" }}>
                                    {this.state.textPickerOne}
                                </span>
                                <span style={{ float: "right" }}>
                                    <RightOutline style={{ fontSize: "20px", color: "#d7d7d7" }} />
                                </span>
                            </div>

                            <Picker
                                columns={this.state.pickerOne}
                                visible={this.state.visibleOne}
                                onClose={() => {
                                    this.setState({
                                        visibleOne: false
                                    })
                                }}
                                value={[this.state.valuePickerOne]}
                                onConfirm={(v) => {
                                    var value = v[0];
                                    var item = this.state.pickerOne[0].filter(x => x.value == value)
                                    this.setState({
                                        valuePickerOne: value,
                                        textPickerOne: item[0].label
                                    })
                                }}
                            />
                        </Form.Item>

                        <Form.Item
                            name='FamilyRelationName'
                            label='Ta称呼你为'
                            rules={[{ required: true, message: '请输入相关内容' }]}
                        >
                            <Input onChange={console.log} placeholder='请输入相关内容' />
                        </Form.Item>

                        {/* <Form.Item className="xinyang" name='FamilyRelationTwo' label="Ta称呼你为">
                            <div onClick={() => {
                                this.setState({
                                    visibleTwo: true
                                })
                            }} style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end",
                            }}>
                                <span style={{ fontSize: "15px", textAlign: "right", marginRight: "10px" }}>
                                    {this.state.textPickerTwo}
                                </span>
                                <span style={{ float: "right" }}>
                                    <RightOutline style={{ fontSize: "20px", color: "#d7d7d7" }} />
                                </span>
                            </div>

                            <Picker
                                columns={this.state.pickerTwo}
                                visible={this.state.visibleTwo}
                                onClose={() => {
                                    this.setState({
                                        visibleTwo: false
                                    })
                                }}
                                value={[this.state.valuePickerTwo]}
                                onConfirm={(v) => {
                                    var value = v[0];
                                    var item = this.state.pickerTwo[0].filter(x => x.value == value)
                                    this.setState({
                                        valuePickerTwo: value,
                                        textPickerTwo: item[0].label
                                    })
                                }}
                            />
                        </Form.Item> */}

                        <Form.Item name='Sex' label='逝者性别'>
                            <Radio.Group>
                                <Space direction='horizontal'>
                                    <Radio value={true}>女</Radio>
                                    <Radio value={false} style={{ marginLeft: "10px" }}>男</Radio>
                                </Space>
                            </Radio.Group>
                        </Form.Item>


                        <Form.Item
                            name='Birthday'
                            label='出生日期'
                            trigger='onConfirm'
                            onClick={(e, datePickerRef) => {
                                datePickerRef.current.open()
                            }}
                            rules={[{ required: true, message: '请选择出生日期' }]}
                        >
                            <DatePicker
                                min={new Date(1900, 0, 1)}
                                max={new Date()}
                            >
                                {value =>
                                    value ? dayjs(value).format('YYYY-MM-DD') : '请选择日期'
                                }
                            </DatePicker>
                        </Form.Item>

                        <div className="DeadDate">
                            <Form.Item
                                name='DeadDate'
                                label='逝世日期'
                                trigger='onConfirm'
                                onClick={(e, datePickerRef) => {
                                    datePickerRef.current.open()
                                }}
                                rules={[{ required: true, message: '请选择逝世日期' }]}
                            >
                                <DatePicker
                                min={new Date(1900, 0, 1)}
                                max={new Date()}>
                                    {value =>
                                        value ? dayjs(value).format('YYYY-MM-DD') : '请选择日期'
                                    }
                                </DatePicker>
                            </Form.Item>
                        </div>

                        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
                            <Grid columns={3} gap={8}>
                                <Grid.Item span={1}>
                                    <div style={{
                                        textAlign: "center", lineHeight: "60px", fontSize: "0.373333rem",
                                        fontWeight: "600", color: "var(--adm-color-text-secondary)",
                                    }}>
                                        上传头像
                                    </div>
                            </Grid.Item>
                                <Grid.Item span={2}>

                                    <ImageUploader
                                        columns={3}
                                        maxCount={1}
                                        style={{ '--cell-size': '80px' }}
                                        value={this.state.fileList || []}
                                        defaultValue={this.state.fileList || []}
                                        beforeUpload={async (file) => {
                                            console.log('BeforeUpload - 文件信息:', file);
                                            if (!(file instanceof File)) {
                                                Toast.show({ icon: 'fail', content: '无效的文件！' });
                                                return false;
                                            }
                                            if (file.size > 5 * 1024 * 1024) {
                                                Toast.show({ icon: 'fail', content: '文件大小不能超过5MB！' });
                                                return false;
                                            }

                                            if (this.state.id != 0) {
                                                var res = await GetSystemMemorys(this.state.id);
                                                if (res.success) {
                                                    var count = 0;
                                                    res.result.map(item => {
                                                        count += item.fileSize;
                                                    })
                                                    var maxSize = 300;
                                                    var models = this.state.userInfo.planetSizes
                                                        .filter(x => x.planetId == this.state.id);
                                                    if (models != null && models.length > 0) {
                                                        maxSize = models[0].fileSumSize;
                                                    }
                                                    if (count > maxSize) {
                                                        Toast.show({ content: '该星球文件空间已满！' });
                                                        return false;
                                                    }
                                                }
                                            }
                                            const fileCopy = new File([file], file.name, { type: file.type });
                                            return fileCopy;
                                        }}
                                        onChange={(fileList) => {
                                            console.log('OnChange - 文件列表:', fileList);
                                            this.setState({ fileList });
                                        }}
                                        upload={async (file) => {
                                            try {
                                                console.log('Upload - 开始上传:', file);

                                                // 1. 验证文件对象
                                                if (!(file instanceof File)) {
                                                    throw new Error('无效的文件对象');
                                                }

                                                // 2. 创建临时预览URL
                                                const tempUrl = URL.createObjectURL(file);
                                                console.log('临时预览URL创建成功:', tempUrl);

                                                // 3. 上传文件
                                                const formData = new FormData();
                                                formData.append('file', file);
                                                formData.append('userid', this.state.userInfo.id);
                                                formData.append('scoureName', "Img");
                                                if (this.state.id != 0) {
                                                    formData.append('planetId', this.state.id);
                                                }

                                                const response = await SaveNNFile(formData);
                                                console.log('上传响应:', response);

                                                // 4. 确保返回正确的URL格式
                                                let imageUrl;
                                                if (typeof response === 'string') {
                                                    imageUrl = environment.apiEndpoint + `/NNFiles/Img/${response.result}`;
                                                } else if (response.result) {
                                                    imageUrl = environment.apiEndpoint + `/NNFiles/Img/${response.result}`;
                                                } else {
                                                    throw new Error('无效的服务器响应');
                                                }

                                                this.setState({
                                                    imgName: response.result
                                                })
                                                // 5. 释放临时URL
                                                URL.revokeObjectURL(tempUrl);

                                                return {
                                                    url: imageUrl
                                                };
                                            } catch (error) {
                                                console.error('上传过程出错:', error);
                                                Toast.show({ icon: 'fail', content: '上传失败' });
                                                throw error;
                                            }
                                        }}
                                        deleteIcon={
                                            <Image src={"https://api.weibinyi.com/images/niannian/4/40-13.png"} fit='fill'
                                                width={14} height={14} />
                                        }
                                        children={
                                            <Image
                                                src="https://api.weibinyi.com/images/niannian/4/2-12.png"
                                                fit="fill"
                                                width={80}
                                                height={80}
                                            />
                                        }
                                    />
                                </Grid.Item>
                            </Grid>

                        </div>

                    </Form>

                </div>


                <BottomMenu  position="absolute" selectKey="home" />

            </div>
        )
    }
}

export default withNavigate(Index);